import { ref } from 'vue';
import axios from 'axios';
import api from '@/services/api';

export default function useApi() {
  const isLoading = ref(false);

  const apiCall = async (url, method = 'GET', data = null) => {
    isLoading.value = true;
    try {
      const response = await api;
      axios({
        url,
        method,
        data,
      });
      return response.data;
    } catch (error) {
      console.error('API call error:', error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  const apiGet = async (url, params) => {
    isLoading.value = true;
    const response = await api.get(url, params);
    isLoading.value = false;
    return response;
  };

  const apiPost = async (url, data) => {
    isLoading.value = true;
    const response = api.post(url, data);
    isLoading.value = false;
    return response;
  };

  const apiPut = async (url, data) => {
    isLoading.value = true;
    const response = api.put(url, data);
    isLoading.value = false;
    return response;
  };

  const apiDelete = async (url) => {
    isLoading.value = true;
    const response = api.delete(url);
    isLoading.value = false;
    return response;
  };

  const apiGetError = (err) => {
    if (err && err.response && err.response.data && err.response.data.message) {
      return err.response.data.message;
    }
    return 'Ha ocurrido un error al intentar actualizar los datos.';
  };

  return {
    isLoading,
    apiGet,
    apiPost,
    apiPut,
    apiDelete,
    apiGetError,
  };
}
